import conferenceConfig from './conference'
// NOTE: in order to not have a circular dependency, none of the other phases can import this file. It can only import from the other phases.
const afterConferenceConfig = {
  starts: conferenceConfig.ends,
  // NOTE: This is generally 6 months after the conference ends, which is when registration for the next conference starts. We want to keep the after conference experience open until then.
  ends: '2027-09-23T08:00:00-07:00',
}

export default afterConferenceConfig
